import { mergeTheme } from '@repo/lib';

export default function getPageTheme(page) {
  return mergeTheme(page.theme, page.themeOverrides, page.seller, {
    brandColor: 'fillsUnsetColors',
  });
}
